var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"map",staticClass:"map"},[_c('my-head',{attrs:{"title":"驾驶员位置"}}),_vm._v(" dwqqqqqqqqqqq ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }